<template>
	<v-container style="padding-top:10px !important;">
		<div class="popCon_input_W100_cov row_mt-20">                
			<v-text-field class="inputH48_01"
				label="이메일"
				placeholder="이메일 변경 못함"
				outlined
				dense
				disabled
				v-model= accountform.email
			>
			</v-text-field>
		</div>
		<div class="popCon_txt">아래 회원 정보를 입력하신 후 다음 버튼을 눌러주세요.</div>
		<div class="popCon_input_W100_cov">
			<!--<div class="signup_pic_cov">
					<div class="label_st00 mb-2">프로필 사진</div>
					<div class="org_pic_cov">
						<div class="org_pic"></div>
						<v-btn class="btnO_C01 edit_pic" @click="dialogImg = true"><span class="icon"></span></v-btn>
					</div>
			</div>-->
			<div class="signup_info_cov">
				<v-form ref="accountforms" v-model="valid" lazy-validation>
			<v-row no-gutters>
				<v-col cols="12">
					<v-text-field class="inputH48_01 inputH48_left_btn_before conBstar"
					label="아이디"
					placeholder="사용할 아이디 입력"
					v-model="accountform.userid"
					:rules="rules.useridRules"
					outlined
					dense
				>
				</v-text-field>
				<v-btn text class="btn17_C01" @click="isValidID">ID중복검사</v-btn>
				<div v-if="this.accountform.userid !== '' && this.isCheckId === this.accountform.userid && !this.isAlreadyUse" class="signup_info_txtOK">사용가능한 아이디입니다</div>
				<div v-if="this.accountform.userid !== '' && this.isCheckId !== this.accountform.userid && this.isAlreadyUse" class="signup_info_txtNo">사용불가능한 아이디입니다</div>
				</v-col>
				<v-col cols="6">
					<v-text-field class="inputH48_01 W90 conBstar"
						label="비밀번호"
						placeholder="영어, 숫자 포함. 6~12자리로 입력"
						outlined
						dense
						v-model="accountform.password"
						:type="'password'"
						:rules="rules.passwordRules"
					>
					</v-text-field>
				</v-col>
				<v-col cols="6">
					<v-text-field class="inputH48_01 W90 conBstar"
						label="비밀번호 확인"
						placeholder="영어, 숫자 포함. 6~12자리로 입력"
						outlined
						dense
						v-model="accountform.password_re"
						:type="'password'"
						:rules="[(accountform.password === accountform.password_re) || '비밀번호가 일치하지않습니다']"
						
					>
					</v-text-field>
				</v-col>
				<v-col cols="6">
					<v-text-field class="inputH48_01 W90 conBstar"
						label="이름"
						placeholder="사용자 이름"
						outlined
						dense
						v-model="accountform.name"
						:rules="rules.nameRules"
					>
					</v-text-field>
				</v-col>
				<v-col cols="6">
					<v-text-field class="inputH48_01 W90 conBstar"
						label="연락처"
						placeholder="SMS 수신용 휴대폰번호"
						outlined
						dense
						v-model="accountform.phone"
						:rules="rules.phoneRules"
					>
					</v-text-field>
				</v-col>
				<v-col cols="12">
					<v-text-field class="inputH48_01 W90 conBstar"
						label="주소"
						placeholder=" "
						outlined
						dense
						v-model="accountform.addr_main"
						:rules="rules.addrMainRules"
					>
					</v-text-field>
				</v-col>
					<v-col cols="12">
					<v-text-field class="inputH48_01 W90 conBstar"
						label="상세주소"
						placeholder=" "
						outlined
						dense
						v-model="accountform.addr_sub"
						:rules="rules.addrSubRules"
					>
					</v-text-field>
				</v-col>
			</v-row>
						</v-form>
			</div>
		</div>
		<v-card-actions class="justify-center signup_btnCon">
			<v-btn outlined class="btn19_00 btnC_01 btn_bottom_W314" @click="submitForm('accountform')">다음</v-btn>
			<!--다음으로 이동-->
		</v-card-actions>
		<s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
	</v-container>
</template>
<script>
import { isValid } from '@/api/join'

export default {
	name: 'registerUser',
	props:{
		parentData: {}
	},
  data () {
    return {
			rules: {
				useridRules: [
					v => !!v || '아이디를 입력해 주세요',
					v => /^[a-zA-Z0-9]{6,12}$/.test(v) || '영어, 숫자 포함하여 6~12자리로 입력해 주십시요'
				],
				passwordRules: [
					v => !!v || '비밀번호를 입력해 주세요',
					v => /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,12}$/.test(v) || '영어, 숫자 포함하여 6~12자리로 입력해 주십시요'
				],
				passwordreRules: [
					v => !!v || '비밀번호를 입력해 주세요',
					v => this.accountform.password === this.accountform.passwordre || '비밀번호가 일치하지않습니다'
				],
				nameRules: [
					v => !!v || '이름을 입력해 주세요',
					v => /^[가-힣|a-z|A-Z]{2,16}$/.test(v) || '한글 또는 영문만 2~16자리로 입력해 주십시요'
				],
				phoneRules: [
					v => !!v || '연락처를 입력해주세요',
					v => (/^(01[016789]{1})([0-9]{7,8})$/.test(v) && v.length !==0 ) || '연락처를 정확히 입력해주세요'
				],
				addrMainRules: [
						v => !!v || '주소지를 입력해주세요'
				],
				addrSubRules: [
						v => !!v || '주소지 (상세)를 입력해주세요'
				],
			},
			valid: true,
			isAlreadyUse: false,
			isCheckId: '',
      accountform: {
				auth_key: '',
        email: '',
        radio_trem_paivacy_op1: false,
        radio_trem_paivacy_op2: false,
        userid: '',
        password: '',
        password_re: '',
        name: '',
        addr_main: '',
        addr_sub: '',
        phone: ''
			},
			term_info: {
        TERM_CTR_MAIL: false,
        TERM_MAIL: false
      },
    }
  },
  created () {
		this.accountform = this.parentData
		if (this.$store.state.user.username !== '') {
			this.$refs.confirm.open('confirm', '회원가입', '로그인 사용자입니다. 로그아웃 후 이용하세요').then(() => {
				this.$router.push('/')
			})
		} else {
			this.mounted()
		}
  },
  methods: {
    mounted () {
      if (this.accountform.auth_key === undefined) {
        // console.log('not found auth_key')
        this.invalid_authkey()
			}
      this.term_info.TERM_CTR_MAIL = this.accountform.radio_trem_paivacy_op1
      this.term_info.TERM_MAIL = this.accountform.radio_trem_paivacy_op2
		},
		isValidID () {
      if (this.accountform.userid === '') {
				this.$refs.confirm.open('alert', '회원가입', '아이디(ID)를 입력하세요')
			} else if(this.accountform.userid.length < 6 || this.accountform.userid.length > 12) {
				this.$refs.confirm.open('alert', '회원가입', '아이디(ID)를 확인해주세요')
			} else {
        this.isAlreadyUse = false
        this.isCheckId = ''
        isValid(JSON.stringify({ userID: this.accountform.userid })).then(Response => {
          if (Response.rdata.isValid) {
            this.isCheckId = this.accountform.userid
          }else{
						this.isAlreadyUse = true
					}
        })
      }
		},
		submitForm (formName) {
			var validate = this.$refs.accountforms.validate()
			if (validate) {
				if(this.isCheckId === this.accountform.userid) {
					this.$emit('regUserEvent', this.accountform)
				}else {
					this.$refs.confirm.open('alert', '회원가입', 'ID 중복체크를 해주세요')
				}
			} 
		},
  }
}

</script>
<style scoped>
</style>